import React from 'react';
import {motion} from 'framer-motion';
import {Link, useNavigate} from 'react-router-dom';
import AppAssets from '../../../../shared/assets/AppAssets';
import './Hero.css';
import {useTranslation} from "react-i18next";

const Hero: React.FC = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();


    const handleLinkClick = (path: string) => {
        window.scrollTo(0, 0);
        navigate(path);
    };

    return (
        <section className="hero-container">
            {/* LCP element: preloaded with fetchpriority="high" in
                public/index.html, so it must not also be lazy-loaded. */}
            <img
                className="hero-video-background"
                src={AppAssets.heroBackground}
                alt="Atelier A2S SARL : usinage et maintenance industrielle à Tanger"
                width={1920}
                height={1080}
                fetchPriority="high"
                decoding="async"
                onError={(e) => {
                    e.currentTarget.src = '/images/background/header-bg.webp';
                }}
            />


            <div className="hero-overlay"></div>
            <div className="container">
                <div className="hero-content">
                    <motion.div
                        initial={{opacity: 0, y: 50}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8}}
                    >
                        <h1 className="hero-title">
                            <div className="stencil-font">
                                {t('home.hero.title', 'AFRICA SUPPLY SERVICE')}
                            </div>

                            <span>
                                {t('home.hero.description', 'Votre partenaire en solutions industrielles')}
                            </span>
                        </h1>

                        <p className="hero-tagline">
                            {t('home.hero.tagline', 'Maintenance • Fourniture industrielle • Installation • Solutions techniques')}
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{opacity: 0, y: 50}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8, delay: 0.6}}
                    >
                        <div className="hero-buttons">
                            <Link to="/services" className="hero-button btn btn-primary"
                                  onClick={() => handleLinkClick('/services')}
                            >{t('home.hero.services', 'Nos domaines d’intervention')}
                            </Link>
                            <Link to="/contact" className="hero-button btn btn-outline"
                                  onClick={() => handleLinkClick('/contact')}
                            >
                                {t('home.hero.contact', 'Contactez-nous')}
                            </Link>
                        </div>
                    </motion.div>
                </div>
            </div>

            <motion.div
                className="hero-scroll-indicator"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{delay: 1.5, duration: 1}}
            >
                <motion.div
                    className="scroll-line"
                    animate={{
                        y: [0, 12, 0],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        repeatType: "loop"
                    }}
                />
            </motion.div>
        </section>
    );
};

export default Hero;
